import SSO from '@transsion/sso'

const ENV_BASE_URL_MAP = {
  dev: {
    auth: 'https://pfgatewayt.transsion.com',
    perm: 'https://pfgatewayt.transsion.com',
  },
  sit: {
    auth: 'https://pfgatewayidct.transsion.com',
    perm: 'https://pfgatewayidct.transsion.com',
  },
  uat: {
    auth: 'https://pfgatewayuat.transsion.com:9199',
    perm: 'https://pfgatewayuat.transsion.com:9199',
  },
}

const PROD_BASE_URL_MAP = {
  auth: {
    hk: 'https://pfgateway.transsion.com:9199',
    in: 'https://oneworksin.transsion.com:9099',
    fra: 'https://pfgatewayfra.transsion.com:9199',
    sz: 'https://pfgatewaysz.transsion.com:9199',
    ee1: 'https://pfgatewayee1.transsion.com',
    oci: 'https://pfgatewayin.transsion.com',
    sg: 'https://pfgatewaysg.transsion.com',
  },
  perm: {
    hk: 'https://pfgateway.transsion.com:9199',
    in: 'https://oneworksin.transsion.com:9099',
    fra: 'https://pfgatewayfra.transsion.com:9199',
    sz: 'https://pfgatewaysz.transsion.com:9199',
    ee1: 'https://pfgatewayee1.transsion.com',
    oci: 'https://pfgatewayin.transsion.com',
    sg: 'https://pfgatewaysg.transsion.com',
  },
}

export default new SSO({
  env: process.env.VUE_APP_ENV,
  appConfig: {
    authId: process.env.VUE_APP_AUTH_ID,
    authCode: process.env.VUE_APP_AUTH_CODE,
  },
  location: process.env.VUE_APP_LOCATION,
  lang: () => '',
  /**
   * 重写 baseUrl 方法
   * @param {*} serviceType auth | perm
   * @param {*} env dev | sit | uat | prod
   * @param {*} location env 为prod时得补充 location hk | in | fra | sz | ee1 | oci | sg
   * @returns string baseUrl
   */
  baseUrl: (serviceType, env = 'prod', location = 'hk') => {
    if (env === 'prod') {
      if (location === 'sg') {
        // location === sg 才走 sg 的网关
        return PROD_BASE_URL_MAP[serviceType][location]
      }

      // 其他环境一律走 hk 网关
      return PROD_BASE_URL_MAP[serviceType]['hk']
    }

    return ENV_BASE_URL_MAP[env][serviceType]
  },
})
